import { createStyles, Theme } from '@material-ui/core/styles';
import { StyleRules } from '@material-ui/core/styles/withStyles';
import { app } from '../../../theme';

const styles = (theme: Theme): StyleRules<string, {}> => createStyles({
  root: {
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
  },
  progressContainer: {
    height: '100vh',
    display: 'flex',
    flex: 1,
  },
  messageBoxContent: {
    padding: theme.spacing(2),
  },
  messageBoxButtons: app.dialog.messageBox.buttons(theme),
  messageBoxBackdrop: {
    transition: 'all ease-out 0.3s',
  },
  messageBoxBackdropBlur: {
    backdropFilter: 'blur(6px)',
  },
});

export default styles;
